/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_No_Resumes_HintInputs */

const en_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resumes found. Create one on the resumes page first.`)
};

const de_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Lebensläufe gefunden. Erstelle zuerst einen auf der Lebensläufe-Seite.`)
};

const fr_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun CV trouvé. Créez-en un depuis la page CVs d'abord.`)
};

const es_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron CVs. Crea uno en la página de CVs primero.`)
};

const it_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun CV trovato. Creane uno dalla pagina CV prima.`)
};

const nl_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen cv's gevonden. Maak er eerst een aan op de cv-pagina.`)
};

const pl_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono CV. Utwórz najpierw jedno na stronie CV.`)
};

const fi_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluetteloita ei löytynyt. Luo ensin ansioluettelo ansioluettelo-sivulta.`)
};

const da_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen CV'er fundet. Opret et fra CV-siden først.`)
};

const sv_keyword_optimizer_no_resumes_hint = /** @type {(inputs: Keyword_Optimizer_No_Resumes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga CV:n hittades. Skapa ett från CV-sidan först.`)
};

/**
* | output |
* | --- |
* | "No resumes found. Create one on the resumes page first." |
*
* @param {Keyword_Optimizer_No_Resumes_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_no_resumes_hint = /** @type {((inputs?: Keyword_Optimizer_No_Resumes_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_No_Resumes_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_no_resumes_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_no_resumes_hint(inputs)
	return en_keyword_optimizer_no_resumes_hint(inputs)
});